import React, { useEffect, useRef, useState } from "react";
import dotIcon from "../../../../assets/img/company/actions-icon.svg";
import { i18n } from "../../private/languageSelector";
import { getEnvironmentLabel, getPosEnvironment } from "./zatcaEnvironment";
import { Field, Form, Formik } from "formik";
import { Input } from "../../../../_metronic/_partials/controls";
import ZatcaModal from "./Modal";
import PinInput from "react-pin-input";
import pasteIcon from "../../../../assets/img/company/copyIcon.svg";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import * as zatcaActions from "../../../../_redux/zatca/zatcaActions";
import * as actions from "../../../../_redux/pos/posActions";
import ENVIRONMENT from "../../../../config/environment";

function CertificateDetails({ posForEdit, setLogsLoading }) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [showRevokeModal, setShowRevokeModal] = useState(false);
  const [showRenewModal, setShowRenewModal] = useState(false);
  const [otpValue, setOtpValue] = useState("");

  // The POS's own environment (pos.zatca.environment) - also what a renewal must be sent with
  const posEnvironment = getPosEnvironment(posForEdit);
  const { user } = useSelector((state) => ({
    user: state?.auth?.user,
  }));
  let backOfficeAccess = user?.rolePayload?.backOfficePayload;
  const zatcaManagemntAccess = backOfficeAccess[9]?.selected && backOfficeAccess[9]?.subItem[0]?.selected;

  const initialValues = {
    csid: posForEdit?.zatca?.certificateId,
    type: getEnvironmentLabel(posEnvironment),
    status: posForEdit?.zatca?.certificateId && !posForEdit?.zatca?.isExpired ? i18n("Integration.Active") : i18n("Integration.Inactive"),
    issued: moment(posForEdit?.zatca?.onboardedAt)?.format("DD MMM YYYY"),
    expired:
      !posForEdit?.zatca?.isExpired && posForEdit?.zatca?.expiresAt
        ? moment(posForEdit?.zatca?.expiresAt)?.format("DD MMM YYYY")
        : posForEdit?.zatca?.isExpired
        ? "Expired"
        : "",
  };
  const revokeRef = useRef();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (revokeRef.current && !revokeRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const language = localStorage.getItem("language") || user?.language || "english";
  const onHide = () => {
    setShowRevokeModal(false);
  };
  const onRenewHide = () => {
    setShowRenewModal(false);
  };

  const onRenewConfirmation = () => {
    if (zatcaManagemntAccess) {
      // Renew in the POS's own environment - the backend rejects any other (the environment is locked)
      dispatch(zatcaActions.OnboardPosToZatca(posForEdit?._id, otpValue, posEnvironment, setShowRenewModal)).then(() => {
        setOtpValue("");
        onRenewHide();
        setLogsLoading(true);
        if (posForEdit?._id) {
          dispatch(actions.fetchPos(posForEdit?._id));
        }
      });
    }
  };

  const handleShowRevokeModal = () => {
    if (zatcaManagemntAccess) {
      setShowRevokeModal(true);
      setShowDropdown(false);
    }
  };
  const handleShowRenewModal = () => {
    if (zatcaManagemntAccess) {
      setShowRenewModal(true);
      setShowDropdown(false);
    }
  };
  const handlePaste = async () => {
    try {
      let text = await navigator.clipboard.readText();
      text = text.replace(/\D/g, "").slice(0, 6); // only numbers, max 6
      console.log("Pasted OTP:", text);
      setOtpValue(text);
    } catch (err) {
      console.error("Clipboard access denied", err);
    }
  };
  const dispatch = useDispatch();

  const expireCertificateInTwoMinutes = () => {
    if (posForEdit?._id && zatcaManagemntAccess) {
      dispatch(zatcaActions.expireCertificateInTwoMinutes(posForEdit?._id));
    }
  };

  const handleRevokeCertificate = () => {
    if (zatcaManagemntAccess) {
      if (posForEdit?._id) {
        dispatch(zatcaActions.revokePosCertificate(posForEdit?._id)).then(() => {
          dispatch(actions.fetchPos(posForEdit?._id));
          setLogsLoading(true);
        });
      }
      onHide();
    }
  };
  const handleForceRevokeFailCertificate = () => {
    if (zatcaManagemntAccess) {
      if (posForEdit?._id) {
        dispatch(zatcaActions.revokePosCertificate(posForEdit?._id, true)).then(() => {
          dispatch(actions.fetchPos(posForEdit?._id));
          setLogsLoading(true);
        });
      }
      onHide();
    }
  };
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center" style={{ marginTop: ".5rem" }}>
        <div className="certificate-text">{i18n("Integration.CertificateDetails")}</div>
        {ENVIRONMENT.showTestTools && !posForEdit?.zatca?.isExpired ? (
          <div
            className="rounded p-2"
            style={{
              color: zatcaManagemntAccess ? "#FF5F57" : "#D3D3D3",
              background: "#f9f9f9",
              pointerEvents: zatcaManagemntAccess ? "all" : "none",
              cursor: zatcaManagemntAccess ? "pointer" : "not-allowed",
            }}
            onClick={expireCertificateInTwoMinutes}
          >
            Expire in 2 Mins
          </div>
        ) : null}

        <div>
          <div className="d-flex actions-wrapper justify-content-center align-items-center" onClick={() => setShowDropdown(!showDropdown)}>
            <img src={dotIcon} alt="dot-icon" />
            <img src={dotIcon} alt="dot-icon" />
            <img src={dotIcon} alt="dot-icon" />
          </div>
        </div>
      </div>
      <div className="relative" style={{ marginTop: "2.5rem" }}>
        <Formik enableReinitialize={true} initialValues={initialValues}>
          {({ handleSubmit, values, setFieldValue, setErrors, errors }) => {
            if (errors?.environmentType?.length > 0) {
              setErrors({ environmentType: "" });
            }
            return (
              <>
                <Form className={`form form-label-right ${language === "arabic" ? "rtl" : "ltr"}`}>
                  <div className="form-group mt-5">
                    <Field
                      name="csid"
                      component={Input}
                      placeholder={i18n("Integration.CSID")}
                      label={i18n("Integration.CSID")}
                      readOnly={true}
                      disabled={true}
                    />
                  </div>
                  <div className="form-group mt-5">
                    <Field
                      name="type"
                      component={Input}
                      placeholder={i18n("Integration.Type")}
                      label={i18n("Integration.Type")}
                      readOnly={true}
                      disabled={true}
                    />
                  </div>
                  <div className="form-group mt-5">
                    <Field
                      name="status"
                      component={Input}
                      placeholder={i18n("Integration.Status")}
                      label={i18n("Integration.Status")}
                      readOnly={true}
                      disabled={true}
                    />
                  </div>
                  <div className="form-group mt-5">
                    <Field
                      name="issued"
                      component={Input}
                      placeholder={i18n("Integration.Issued")}
                      label={i18n("Integration.Issued")}
                      readOnly={true}
                      disabled={true}
                    />
                  </div>
                  <div className={`form-group mt-5 ${posForEdit?.zatca?.isExpired ? "expired-text" : ""}`}>
                    <Field
                      name="expired"
                      component={Input}
                      placeholder={i18n("Integration.Expires")}
                      label={i18n("Integration.Expires")}
                      readOnly={true}
                      disabled={true}
                    />
                  </div>
                </Form>
              </>
            );
          }}
        </Formik>
        {showDropdown ? (
          <div
            style={{
              position: "absolute",
              background: "white",
              right: language === "english" && "2.5rem",
              left: language === "arabic" && "2.5rem",
              top: "4rem",
              boxShadow: "0px 4px 4px 0px #00000040",
            }}
            ref={revokeRef}
          >
            <div className="d-flex flex-column" style={{ gap: ".5rem", padding: "15px" }}>
              <div className={`renew-text ${!zatcaManagemntAccess ? "restricted-text" : ""}`} onClick={handleShowRenewModal}>
                {i18n("Integration.Renew")}
              </div>
              <div className={`revoke-text ${!zatcaManagemntAccess ? "restricted-text" : ""}`} onClick={handleShowRevokeModal}>
                {i18n("Integration.Revoke")}
              </div>
            </div>
          </div>
        ) : null}
        <div>
          <ZatcaModal
            title={i18n("Integration.RevokeCertificate")}
            description={i18n("Integration.RevokeConfirmationText")}
            show={showRevokeModal}
            onHide={onHide}
            primaryActionText={i18n("Integration.CANCEL")}
            secondaryActionText={i18n("Integration.REVOKE")}
            applyCustomWidth
            onConfirm={handleRevokeCertificate}
            onFailure={handleForceRevokeFailCertificate}
          />
        </div>
        <div>
          <ZatcaModal
            title={""}
            description={
              <>
                <div style={{ marginTop: "1rem" }}>
                  <div className="pin-code-text">
                    {language === "arabic" ? (
                      <> أدخل رمز التحقق الذي استلمته من بوابة فاتورة، أو قم بزيارة موقع هيئة الزكاة للحصول على الرمز.</>
                    ) : (
                      <>
                        Enter the verification code you received from the Fatoora portal, or Visit the{" "}
                        <a className="main-text" target="_blank" href="https://login.zatca.gov.sa/" rel="noopener noreferrer">
                          Zakat
                        </a>{" "}
                        website to get the code.
                      </>
                    )}
                  </div>
                  <div className="mt-5 py-4">
                    <div className="d-flex align-items-center justify-content-between">
                      <div className="paste-box p-4 whitespace-nowrap" onClick={handlePaste}>
                        <img src={pasteIcon} alt="paste-icon" />
                        <span className="mx-3">{i18n("Integration.Paste")}</span>
                      </div>
                      <div className="form-group ltr mb-0">
                        <PinInput
                          length={6}
                          initialValue={otpValue}
                          key={otpValue}
                          secret={false}
                          focus={false}
                          type="numeric"
                          style={{ width: "100%" }}
                          inputStyle={{
                            width: "35px",
                            height: "35px",
                            marginLeft: ".8rem",
                            marginRight: ".8rem",
                            borderRadius: "5px",
                            border: "1px solid #B3B3B3",
                            fontSize: "14px",
                            background: "transparent",
                            color: "#000000",
                            direction: "ltr",
                            marginTop: ".5rem",
                            marginBottom: ".5rem",
                          }}
                          onChange={(value) => setOtpValue(value)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </>
            }
            show={showRenewModal}
            onHide={onRenewHide}
            onConfirm={onRenewConfirmation}
            secondaryActionText={i18n("Integration.RENEW")}
            secondaryColor={"#2D9CDB"}
            disabled={otpValue?.length >= 6 ? false : true}
          />
        </div>
      </div>
    </div>
  );
}

export default CertificateDetails;
